// extracted by mini-css-extract-plugin
export default {"resumeBox":"JobHistory_resumeBox__atD9R","icon":"JobHistory_icon__7JYPx","time":"JobHistory_time__ejyQn","place":"JobHistory_place__ranju"};